import { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Snackbar,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../Config/api";

const MilestoneForm = ({
  isViewMode,
  isEditMode,
  selectedPatientID,
  selectedProfessional,
  selectedId,
  selectedDates,
  onClose,
  tableData,
  startDate,
  endDate,
  selectedProfessionalId,
  formData,
}) => {
  console.log(tableData, "tableData", startDate, endDate);
  console.log(formData, "data formDataformData");

  // const port = process.env.REACT_APP_API_KEY;
  const accessToken = localStorage.getItem("token");
  const [observership, setObservership] = useState(null);
  const [callType, setCallType] = useState("");
  const [caseDetails, setCaseDetails] = useState("");
  const [observation, setObservation] = useState("");
  const [recommendation, setRecommendation] = useState("");
  const [remark, setRemark] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarText, setSnackbarText] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [errors, setErrors] = useState({});
  const [data, setData] = useState([]);
  const [totalMarks, setTotalMarks] = useState({ obtained: 0, outOf: 0 });
  const [isMarksEdited, setIsMarksEdited] = useState(false);

  const navigate = useNavigate();
  const username = localStorage.getItem("user-name");

  const isTableDataValid =
    Array.isArray(tableData) &&
    tableData.length > 0 &&
    !(tableData.length === 1 && tableData[0] === "data not found");

  const isSubmitDisabled =
    !isTableDataValid ||
    !startDate ||
    !endDate ||
    !selectedProfessional ||
    !selectedPatientID;

  const validateForm = () => {
    const newErrors = {};

    if (!observership && !formData?.underwent_observership) {
      newErrors.observership = "This field is required";
    }

    if (!callType && !formData?.call_type) {
      newErrors.callType = "This field is required";
    }

    if (
      (!caseDetails || !caseDetails.trim()) &&
      (!formData?.case_dtls_complaints || !formData?.case_dtls_complaints.trim())
    ) {
      newErrors.caseDetails = "This field is required";
    }

    if (
      (!observation || !observation.trim()) &&
      (!formData?.observation || !formData?.observation.trim())
    ) {
      newErrors.observation = "This field is required";
    }

    if (
      (!recommendation || !recommendation.trim()) &&
      (!formData?.recommendation || !formData?.recommendation.trim())
    ) {
      newErrors.recommendation = "This field is required";
    }

    if (
      (!remark || !remark.trim()) &&
      (!formData?.remark || !formData?.remark.trim())
    ) {
      newErrors.remark = "This field is required";
    }

    // ✅ At least one question must have marks entered
    const hasAtLeastOneMark = data.some(
      (item) =>
        item.marks !== "" && item.marks !== null && item.marks !== undefined
    );

    if (!hasAtLeastOneMark) {
      newErrors.questionMarks = "Please enter marks for at least one question";
      setSnackbarText("Please enter marks for at least one question ❗");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    if (!isEditMode) {
      if (!selectedProfessional) {
        setSnackbarText("Please select a Professional");
        setSnackbarSeverity("warning");
        setSnackbarOpen(true);
        return;
      }

      if (!selectedPatientID) {
        setSnackbarText("Please select a Patient");
        setSnackbarSeverity("warning");
        setSnackbarOpen(true);
        return;
      }

      if (!selectedDates) {
        setSnackbarText("Please select Dates");
        setSnackbarSeverity("warning");
        setSnackbarOpen(true);
        return;
      }

      if (!Array.isArray(tableData) || tableData.length === 0) {
        setSnackbarText("Please search and select data before submitting.");
        setSnackbarSeverity("warning");
        setSnackbarOpen(true);
        return;
      }
    }

    const question_and_marks = [];
    data.forEach((item, i) => {
      question_and_marks.push({
        question_id: item.id ?? i + 1,
        marks: Number(item.marks) || 0,
      });
    });

const payload = {
  // ✅ If user didn't change, use backend value
  underwent_observership:
    observership ?? formData?.underwent_observership ?? null,

  call_type: callType || formData?.call_type || "",
  patient_name: selectedPatientID || formData?.patient_name || "",
  prof_id: selectedProfessionalId || formData?.prof_id || "",
  case_dtls_complaints:
    caseDetails.trim() || formData?.case_dtls_complaints || "",
  observation: observation.trim() || formData?.observation || "",
  recommendation: recommendation.trim() || formData?.recommendation || "",
  remark: remark.trim() || formData?.remark || "",

  added_by: username,
  last_modified_by: username,

  // ✅ Keep both old & new marks
  question_and_marks: data.map((item, i) => ({
    question_id: item.id ?? formData?.question_and_marks?.[i]?.question_id ?? i + 1,
    marks:
      item.marks !== "" && item.marks !== undefined
        ? Number(item.marks)
        : formData?.question_and_marks?.[i]?.marks ?? 0,
  })),

  // ✅ Use calculated marks if edited, else backend total
  Total_marks:
    isEditMode && !isMarksEdited && formData?.Total_marks
      ? formData.Total_marks
      : totalMarks.obtained,
};


    setSubmitting(true);

    try {
      if (selectedId) {
        // Edit/update
        await axios.put(
          `${API_URL}/web/physiotherapy_milestone_update/${selectedId}/`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        setSnackbarText("Updated successfully ✅");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        onClose();
      } else {
        // New submit
        await axios.post(
          `${API_URL}/web/Physiotherapy_Milestone_Post_api/`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        setSnackbarText("Form submitted successfully ✅");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);

        setTimeout(() => {
          navigate("/hhc/physio Quality Audit", { replace: true });
        }, 1000);
      }
    } catch (error) {
      console.error("Error submitting/updating form:", error);
      setSnackbarText("Operation failed ❌");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setSubmitting(false);
    }
  };

 useEffect(() => {
  if ((isEditMode || isViewMode) && formData) {
    setObservership(formData?.underwent_observership || null);
    setCallType(formData?.call_type || "");
    setCaseDetails(formData?.case_dtls_complaints || "");
    setObservation(formData?.observation || "");
    setRecommendation(formData?.recommendation || "");
    setRemark(formData?.remark || "");

    // ✅ load total marks from backend
    if (formData?.Total_marks) {
  // Calculate total "Out Of" from backend questions if available
  const outOfTotal = formData?.question_and_marks
    ? formData.question_and_marks.length * 10
    : data?.length * 10 || 0;

  setTotalMarks({ obtained: formData.Total_marks, outOf: outOfTotal });
}
  }
}, [isEditMode, isViewMode, formData]);




  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_URL}/web/clinical_evaluation_get/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const result = await response.json();
        setData(result);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, [accessToken, API_URL]);

  useEffect(() => {
    if (formData?.question_and_marks) {
      const mappedData = formData.question_and_marks.map((item) => {
        const question = data.find((q) => q.id === item.question_id);
        return {
          ...item,
          parameter: question ? question.parameter : `Fetching...`,
          marks: item.marks ?? "",
        };
      });
      setData(mappedData);
    }
  }, [formData]);

useEffect(() => {
  if (Array.isArray(data) && data.length > 0) {
    // ✅ For add mode → always calculate
    // ✅ For edit mode → calculate only if marks edited
    if (!isViewMode && (!isEditMode || isMarksEdited)) {
      const obtained = data.reduce((sum, item) => {
        const val = Number(item.marks);
        return sum + (isNaN(val) ? 0 : val);
      }, 0);
      const outOf = data.reduce((sum, item) => sum + 10, 0);
      setTotalMarks({ obtained, outOf });
    }
  } else {
    setTotalMarks({ obtained: 0, outOf: 0 });
  }
}, [data, isEditMode, isViewMode, isMarksEdited]);



const handleMarksChange = (index, value) => {
  const num = Number(value);
  if ((num >= 0 && num <= 10) || value === "") {
    setData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index] = {
        ...updatedData[index],
        marks: value === "" ? "" : num,
      };
      return updatedData;
    });
    setIsMarksEdited(true); // ✅ mark that user edited marks
  }
};


  return (
    <Card sx={{ p: 0, boxShadow: "none", mt: 1 }}>
      <CardContent
        sx={{
          maxHeight: "40vh",
          overflowY: "auto",
          overflowX: "hidden",
          paddingRight: 2,
        }}
      >
        {!isEditMode && !isViewMode && (
          <Typography
            fontWeight={600}
            fontSize={14}
            fontFamily={"Roboto"}
            textAlign={"left"}
            p={1}
          >
            Quality Audit
          </Typography>
        )}

        <Grid container spacing={1.7}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Underwent Observership"
              select
              fullWidth
              size="small"
              value={observership ?? ""}
              disabled={isViewMode}
              error={!!errors.observership}
              helperText={errors.observership}
              onChange={(e) => setObservership(e.target.value)}
            >
              <MenuItem value="">
                <em>Select</em>
              </MenuItem>
              <MenuItem value={1}>Yes</MenuItem>
              <MenuItem value={2}>No</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Call Type"
              select
              fullWidth
              size="small"
              value={callType}
              disabled={isViewMode}
              error={!!errors.callType}
              helperText={errors.callType}
              onChange={(e) => setCallType(e.target.value)}
            >
              <MenuItem value={1}>Complain Handle</MenuItem>
              <MenuItem value={2}>Tech Interview</MenuItem>
              <MenuItem value={3}>Quality Audit</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Case Details"
              fullWidth
              size="small"
              multiline
              disabled={isViewMode}
              value={caseDetails}
              error={!!errors.caseDetails}
              helperText={errors.caseDetails}
              onChange={(e) => setCaseDetails(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Observation"
              fullWidth
              size="small"
              multiline
              value={observation}
              disabled={isViewMode}
              error={!!errors.observation}
              helperText={errors.observation}
              onChange={(e) => setObservation(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Recommendation"
              fullWidth
              size="small"
              multiline
              value={recommendation}
              disabled={isViewMode}
              error={!!errors.recommendation}
              helperText={errors.recommendation}
              onChange={(e) => setRecommendation(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Remark"
              fullWidth
              size="small"
              multiline
              value={remark}
              disabled={isViewMode}
              error={!!errors.remark}
              helperText={errors.remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Grid>
        </Grid>

       <Table
  size="small"
  sx={{
    "& .MuiTableCell-root": {
      padding: "4px 8px",
      marginTop: "12px",
    },
    "& .MuiTableRow-root": {
      height: "30px",
    },
  }}
>
  <TableHead>
    <TableRow>
      <TableCell>Name</TableCell>
      <TableCell>Marks (10)</TableCell>
      <TableCell>Out Of</TableCell>
    </TableRow>
  </TableHead>

  <TableBody>
    {data?.map((item, index) => (
      <TableRow key={index}>
        <TableCell>{item.parameter}</TableCell>
        <TableCell>
          <TextField
            type="number"
            variant="outlined"
            size="small"
            disabled={isViewMode}
            value={item.marks}
            onChange={(e) => handleMarksChange(index, e.target.value)}
            inputProps={{ min: 0, max: 10, step: 1 }}
          />
        </TableCell>
        <TableCell>10</TableCell>
      </TableRow>
    ))}
  </TableBody>
</Table>

{/* ✅ Total marks section BELOW the table */}
<Grid container spacing={1} sx={{ mt: 1 }}>
  <Grid item xs={3}>
    <Typography
      sx={{
        fontWeight: 600,
        fontSize: 15,
        textAlign: "left",
      }}
    >
      Total Marks 
    </Typography>
  </Grid>

  <Grid item xs={6}>
      <Typography sx={{ fontWeight: 600, fontSize: 15, textAlign: "right" }}>
      {isEditMode && !isMarksEdited && formData?.Total_marks
        ? formData.Total_marks
        : totalMarks.obtained}
    </Typography>
  </Grid>
    <Grid item xs={3}>
    <Typography
      sx={{
        fontWeight: 600,
        fontSize: 15,
        textAlign: "right",
      }}
    >
    (Out Of): {totalMarks.outOf}
    </Typography>
  </Grid>
</Grid>


        <Grid container justifyContent="center" sx={{ mt: 2 }}>
          {isEditMode ? (
            <Button
              onClick={handleFormSubmit}
              variant="contained"
              sx={{
                backgroundColor: "#347B89",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#347B89",
                },
              }}
            >
              {submitting ? "Updating..." : "Update"}
            </Button>
          ) : (
            <Button
              onClick={handleFormSubmit}
              variant="contained"
              disabled={isSubmitDisabled}
              sx={{
                backgroundColor: isSubmitDisabled ? "#ccc" : "#347B89",
                cursor: isSubmitDisabled ? "not-allowed" : "pointer",
                "&:hover": {
                  backgroundColor: isSubmitDisabled ? "#ccc" : "#347B89",
                },
              }}
            >
              {submitting ? "Submitting..." : "Submit"}
            </Button>
          )}
        </Grid>
      </CardContent>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarText}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default MilestoneForm;
